<template>
  <div class="paises">
    <label for="paises">Pais</label>
    <select class="pointer" v-model="pais" name="paises" id="paises">
      <option value="">Seleccione...</option>
      <option v-for="item in paises" :value="item">{{ item }}</option>
    </select>
    <i class="bar"></i>
  </div>
</template>

<script>
  import InputComp from "../../../../Componentes_Globales/Input/inputComp";
  import paises from "../../../paises"

  export default {
    name: "Paises",
    components: {InputComp},
    computed: {
      pais: {
        get() {
          return this.$store.state.producto.producto.pais
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_PRODUCTO", {key: "pais", value})
        }
      }
    },
    data() {
      return {
        paises
      }
    }
  }
</script>

<style scoped>

</style>
